<template>
    <div style="width: 90%; max-width: 1024px; margin-left: auto; margin-right: auto;">
        <div><h4>ITEMS TO PULL</h4></div>

        <div>
            <div>Select a Pullist </div>
            <b-form-select 
                v-on:change="get_pullist_data"
                size="sm" 
                :options="pullists"
                style="width: 200px;"
            ></b-form-select>
        </div>

        <div>
            <div v-for="item,idx in items">
                <TRTemplateForItemToPull :viewdata="{item: item, idx: idx, packet: packet}" />
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"
    import SimpleScanner from "@/components/importables/SimpleScanner"
    import TRTemplateForItemToPull from "@/components/importables/TRTemplateForItemToPull"

    export default {
        name: "ShippingItemsToPull",
        props: [],
        components: {Backer, SimpleScanner, TRTemplateForItemToPull},
        data: function(){
            return {
                packet: {},
                items: [],
                pullists: [],
            }
        },
        methods: {
            get_pullist_data: function(name){
                let path = "/api/inventory/get_pullist_data/"
                let data = {name: name}
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.items = response.data.result;
                    }
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading locations.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                Requestor.getSyncP(path, data, this, s, f);
            },
            fetch_prereqs: function() {
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/inventory/get_pullists_with_open_items/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.pullists = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading locations.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                ]

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }},
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.packet.global_vars = global_vars;
            if (['admin', 'officeuser'].indexOf(this.packet.userDetails.userrole) < 0){
                let user_location = this.packet.userDetails.properties.location_id;
                this.packet.locations = this.packet.locations.filter(function(d){return d.value == user_location});
            }

            this.fetch_prereqs();
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/Shipping/ShippingItemsToPull.vue